export function getAuthRedirectPath({
  authPath,
  pathname,
  search,
}: {
  authPath: string;
  pathname: string;
  search: string;
}) {
  const searchParams = new URLSearchParams();
  searchParams.set("next", `${pathname}${search}`);
  return `${authPath}?${searchParams.toString()}`;
}

export function shouldRedirectUnauthenticatedRootRoute({
  isAuthenticated,
  isLoadingUser,
  isPublicPath,
  pathname,
}: {
  isAuthenticated: boolean;
  isLoadingUser: boolean;
  isPublicPath: boolean;
  pathname: string;
}) {
  return (
    !pathname.startsWith("/auth") &&
    !pathname.startsWith("/beta") &&
    // /migration redirects logged-out users to signup itself, preserving a `next` return path.
    pathname !== "/migration" &&
    pathname !== "/oauth/authorize" &&
    !isPublicPath &&
    !pathname.startsWith("/external-integrations/") &&
    !isLoadingUser &&
    !isAuthenticated
  );
}
